import { IRectangle, List } from '@fluentui/react';
import { emptyFunc } from '../../../../home/models/OtherTypes';
import { OrderModel } from '../../../models/OrderModel';
import OrderItemCompactView from './OrderItemCompactView';
import OrderItemView from './OrderItemView';

type OrderGridProps = {
    orders: OrderModel[];
    onDetail: (id: number) => void;
    onPlaceOrder: (id: number, onCompleted: emptyFunc) => void;
    onCompleted: () => void;
}

export default function OrderGridView({ orders, onDetail, onPlaceOrder, onCompleted }: OrderGridProps) {
    var columnCount: number = 0;

    const getItemCountForPage = (itemIndex?: number, surfaceRect?: IRectangle): number => {
        if (itemIndex === 0) {
            if (surfaceRect != null && surfaceRect.width < 700) columnCount = 1;
            else if (surfaceRect != null && surfaceRect.width < 1050) columnCount = 2;
            else columnCount = 3;
        }

        return orders.length;
    }

    const onRenderCell = (order?: OrderModel, index?: number, isScrolling?: boolean) => {
        const width = (100 / columnCount) + '%';
        const isMobile = window.innerWidth <= 500;
        const height = columnCount === 1 ? "auto" : 600;
        const innerWidth = window.innerWidth;

        if (order == null) return <>empty</>;

        if (isMobile) {
            return <div
                key={order.id + "-wrapper"}
                className={"list-grid-tile p-10"}
                style={{ width: width, height: "auto" }}
                data-is-focusable={true}
            >
                <OrderItemCompactView
                    key={order.id}
                    order={order}
                    onPlaceOrder={onPlaceOrder}
                    onDetail={onDetail}
                    onCompleted={onCompleted}
                />
            </div>;
        }

        return <div
            key={order.id + "-wrapper"}
            className="list-grid-tile"
            style={{ width: width, height: height }}
            data-is-focusable={true}
        >
            <OrderItemView
                key={order.id}
                order={order}
                onPlaceOrder={onPlaceOrder}
                onDetail={onDetail}
                onCompleted={onCompleted}
            />
        </div>;
    }

    return <div className="ml--20 mr--20">
        <List
            items={orders}
            onRenderCell={onRenderCell}
            getItemCountForPage={getItemCountForPage}
        />
    </div>;
}